import axios from 'axios';
import md5 from 'md5';
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {ReactComponent as More} from '../../assets/new-icons/plus.svg';
import {ReactComponent as Card} from '../../assets/new-icons/card.svg';
import {ReactComponent as Bank} from '../../assets/new-icons/bank2.svg';
import {ReactComponent as Check} from '../../assets/new-icons/check_circle.svg';

import './ChangePayMethod.scss'
import ConfermaBTN from '../../components/ConfermaBTN/ConfermaBTN';
import NewHeader from '../../components/New Header/NewHeader';
import { setPayMethodDefault } from '../../features/gasSlice';

function ChangePayMethod() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const customerId = useSelector((user) => user.gas?.info.customer_id)
    const token = useSelector((user) => user.gas?.datiPagamento.token)
    const iban = useSelector((user) => user.gas?.datiPagamento?.account_iban)
    const defaultMethod = useSelector((user) => user.gas?.payMethodDefault)
    const [ibans, setIbans] = useState([])
    const [cards, setCards] = useState()
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const idContratto = useSelector((user) => user.gas?.info?.contract_id)

    useEffect(() => {
        setIbans([{iban}])
        if(token){
            getCard()
        }
        getMethod()
    },[token, iban])

    const getCard = async () => {
        const apiCard = `https://my.revoluce.it/area_utente/gestione/api/customers/getCarte.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(apiCard)
        setCards(data.data)
    }
    const getMethod = async () => {
        const apiMethod = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getMetodiPagamento.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(apiMethod)
        dispatch(setPayMethodDefault(data.dati.metodo_predefinito))
    }
    const selectMethodIban = async (props) => {
   
        const methodUrl = `https://my.revoluce.it/area_utente/gestione/api/faidate/setMetodoPagamentoGas.php?customer_id=${customerId}&tkn_pvt=${tkn}&id_metodo=17&id_contratto=${idContratto}&id_token=id`
        const { data } = await axios.get(methodUrl)
        getMethod()
    }
    const selectMethodToken = async (props) => {
        const methodUrl = `https://my.revoluce.it/area_utente/gestione/api/faidate/setMetodoPagamentoGas.php?customer_id=${customerId}&tkn_pvt=${tkn}&id_metodo=28&id_contratto=${idContratto}&id_token=${props.id}`
        const { data } = await axios.get(methodUrl)
        getMethod()
    }
    return (
        <div className='changePayMethod'>
            <div className="changePayMethod-top">
                <NewHeader logo="white" padding='no' iconsColor='white' />
            </div>
            <div className='changePayMethod-bottom'>
                <p className="title">Scegli metodo di pagamento:</p>
                <p className="description">Puoi selezionare un metodo di pagamento già registrato o aggiungerne uno nuovo.</p> 
                {iban && ibans.map((iban, i) => (
                    <div key={i} className={`method ${defaultMethod === 'RID' ? 'active' : null}`} onClick={() => selectMethodIban(iban)}>
                        <div className="iconBox">
                            <Bank />
                        </div>
                        <div className="text">
                            <p className="secondary">Iban:</p>
                            <p className='main bold'>********* {iban.iban.slice(iban.iban.length - 4)}</p>
                        </div>
                        {defaultMethod && defaultMethod === 'RID' ? (
                            <div className="check">
                                <Check/>
                            </div>
                        ) : null}
                        
                    </div>
                ))}
                {cards && cards.map((card, i) => (
                    <div key={i} className={`method ${defaultMethod !== 'RID' && card.token_default === '1' ? 'active' : null}`} onClick={() => selectMethodToken(card)}>
                        <div className="iconBox">
                            <Card />
                        </div>
                        <div className="text">
                            <p className='secondary'>Carta di credito</p>
                            <p className='main bold'>**** **** **** {card.token.slice(card.token.length - 4)}</p>
                        </div>
                        {
                            defaultMethod !== 'RID' && card.token_default === '1' ? (
                                <div className="check">
                                    <Check/>
                                </div>
                            ) : null
                        }
                            
                    </div>
                ))}
                <div className="addNewMethod" onClick={() => navigate('/enrica/profilo/aggiungi')}>
                    <div className="iconBox">
                        <More />
                    </div>
                    <div className="text">
                        <p className='main p-14 bold'>Aggiungi nuovo metodo</p>
                    </div>
                </div>
                <ConfermaBTN url="none" confermTxt="Confermi il nuovo metodo di pagamento?" text="Conferma modifica" forward="/enrica/richiesta-inoltrata"/>
                {/* <SwiperButtonTS url="none" forward="/enrica/modifica-effettuata" /> */}
                <div className="empty" style={{height: '100px'}}></div>
            </div>
        </div>
    )
}

export default ChangePayMethod
